import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { generateForm } from '../../form/Form';
import { buildBindings, normalizeParameter } from './helpers';
import { NodeParameter } from './models';

var getOptions = function getOptions(menu) {
  return menu.split(',').filter(function (value) {
    return !!value;
  }).map(function (value) {
    return {
      label: value,
      value: value
    };
  });
};

var dataSources = function dataSources(_ref) {
  var task = _ref.task,
      tasks = _ref.tasks,
      tree = _ref.tree,
      node = _ref.node;
  return {
    bindings: {
      fn: buildBindings,
      params: [tree, tasks, node]
    },
    parameters: {
      fn: function fn() {
        return task.inputs || task.parameters;
      },
      params: [],
      transform: function transform(result) {
        return result.map(normalizeParameter).map(NodeParameter);
      }
    }
  };
};

var fields = function fields(_ref2) {
  var node = _ref2.node,
      task = _ref2.task,
      tasks = _ref2.tasks,
      tree = _ref2.tree;
  return function (_ref3) {
    var bindings = _ref3.bindings,
        parameters = _ref3.parameters;
    return bindings && parameters && [].concat(_toConsumableArray(node.parameters.map(function (parameter) {
      return {
        name: "oldParameter_".concat(parameter.id),
        label: parameter.label,
        type: parameter.menu ? 'select' : 'code',
        language: parameter.menu ? null : 'erb',
        helpText: parameter.description,
        initialValue: parameter.value,
        options: parameter.menu ? getOptions(parameter.menu) : bindings,
        "transient": true,
        enabled: false
      };
    })), _toConsumableArray(parameters.map(function (parameter) {
      var matchingParameter = node.parameters.find(function (oldParameter) {
        return oldParameter.id === parameter.id;
      });
      return {
        name: "parameter_".concat(parameter.id),
        label: parameter.label,
        type: parameter.menu ? 'select' : 'code',
        language: parameter.menu ? null : 'erb',
        helpText: parameter.description,
        initialValue: matchingParameter ? matchingParameter.value : parameter.defaultValue,
        options: parameter.menu ? getOptions(parameter.menu) : bindings,
        "transient": true
      };
    })), [{
      name: 'parameters',
      type: null,
      visible: false,
      serialize: function serialize(_ref4) {
        var parameters = _ref4.parameters,
            values = _ref4.values;
        return parameters.map(function (parameter) {
          return parameter.set('value', values.get("parameter_".concat(parameter.id)));
        });
      }
    }, {
      name: 'id',
      type: 'text',
      visible: false,
      initialValue: node.id
    }, {
      name: 'name',
      type: 'text',
      visible: false,
      initialValue: node.name
    }, {
      name: 'deferrable',
      type: 'checkbox',
      visible: false,
      initialValue: task.deferrable
    }, {
      name: 'defers',
      type: 'checkbox',
      visible: false,
      initialValue: task.deferrable ? node.defers : false
    }, {
      name: 'definitionId',
      type: 'text',
      visible: false,
      initialValue: task.definitionId
    }, {
      name: 'visible',
      type: 'checkbox',
      visible: false,
      initialValue: node.visible
    }, {
      name: 'messages',
      type: null,
      visible: false,
      initialValue: node.messages.filter(function (message) {
        return message.type === 'Complete' || task.deferrable && node.defers;
      })
    }]);
  };
};

var handleSubmit = function handleSubmit(_ref5) {
  var node = _ref5.node;
  return function (values) {
    return values;
  };
};

export var NodeParametersForm = generateForm({
  formOptions: ['node', 'task', 'tasks', 'tree'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
NodeParametersForm.displayName = 'NodeParametersForm';